import { Skeleton } from '@/components/EventCard/Skeleton';

export const LeaguesListSkeleton = () => {
  return (
    <div className='w-full mx-auto !max-w-7xl grid grid-cols-1 min-[500px]:grid-cols-2 gap-3 py-4 md:grid-cols-3 md:gap-6 lg:grid-cols-4 xl:grid-cols-5 2xl:px-0'>
      {Array.from(Array(10).keys()).map((index) => {
        return <Skeleton key={`league-list-skeleton-${index}`} />;
      })}
    </div>
  );
};
